export default class ProductDetailColorSwitchController {
	constructor() {
		this.dom = {
			container: document.querySelector(".productDetailHeroContainer .productOverviewContainer")
		};
		this.containers = [];
		this.currentVariantId = 1;

		if (this.dom.container != null) {
			this.init();
		}
	}

	init() {
		this.setEventListeners();
	}

	setEventListeners() {
		// const arrowButtons = this.dom.container.querySelectorAll('button[data-action]');
		const colorButtons = this.dom.container.querySelectorAll('button[data-color-id]');

		// arrowButtons.forEach(button => {
		// 	button.addEventListener('click', () => {
		// 		const action = button.dataset.action;
		// 		this.setActiveId(action);
		// 		this.showActiveVariant();
		// 	});
		// });

		colorButtons.forEach(button => {
			button.addEventListener('click', () => {
				const variantId = button.dataset.colorId;
				this.currentVariantId = variantId;
				this.showActiveVariant();
			});
		});
	}


	showActiveVariant() {
		//active image
		this.dom.container.querySelectorAll('.productOverviewImageContainer img').forEach(image => {
			image.classList.remove('showProduct');
			if (image.dataset.colorId == this.currentVariantId) {
				image.classList.add('showProduct');
			}
		});

		//active slider
		this.dom.container.querySelectorAll('.productOverviewImageContainer .imageSliderContainer').forEach(slider => {
			slider.classList.remove('showProduct');
			if (slider.dataset.colorId == this.currentVariantId) {
				slider.classList.add('showProduct');
			}
		});

		//active colorchoice
		this.dom.container.querySelectorAll('.productOverviewColorSwitchContainer button.js-productcolorswitchbutton').forEach(button => {
			button.classList.remove('activeColor');
			if (button.dataset.colorId == this.currentVariantId) {
				button.classList.add('activeColor');
			}
		});

		//active price
		this.dom.container.querySelectorAll('.productOverviewContent .productPrice').forEach(price => {
			price.classList.remove('showProduct');
			if (price.dataset.colorId == this.currentVariantId) {
				price.classList.add('showProduct');
			}
		});
	}

	setActiveId(action) {

		switch (action) {
			case "next":
				if (this.currentVariantId < 3) {
					this.currentVariantId++;
				} else if (this.currentVariantId >= 3) {
					this.currentVariantId = 1;
				}
				break;
			case "prev":
				if (this.currentVariantId > 1) {
					this.currentVariantId--;
				} else if (this.currentVariantId <= 1) {
					this.currentVariantId = 3;
				}
				break;
		}
	}
}